// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PorterStoreOrderDetailApiModel from "../api-model/PorterStoreOrderDetailApiModel.bs.js";

function decodeAddress(data) {
  return {
          receiver_name: Belt_Option.getWithDefault(data.receiver_name, ""),
          receiver_phone: Belt_Option.getWithDefault(data.receiver_phone, ""),
          address_line_1: Belt_Option.getWithDefault(data.address_line_1, ""),
          address_line_2: Belt_Option.getWithDefault(data.address_line_2, ""),
          city: Belt_Option.getWithDefault(data.city, ""),
          state: Belt_Option.getWithDefault(data.state, ""),
          postal_code: Belt_Option.getWithDefault(data.postal_code, "")
        };
}

function decodeRequester(data) {
  var detailsName = Belt_Option.flatMap(data.details, (function (d) {
          return d.name;
        }));
  var detailsPhone = Belt_Option.flatMap(data.details, (function (d) {
          return d.phone;
        }));
  var match = data.name;
  var match$1 = data.phone;
  return {
          user_id: data.user_id,
          persona: data.persona,
          name: match !== undefined ? data.name : detailsName,
          phone: match$1 !== undefined ? data.phone : detailsPhone
        };
}

function decodeProduct(data) {
  return {
          code: data.code,
          name: data.name,
          description: data.description,
          is_active: data.is_active,
          image_url: data.image_url
        };
}

function decodeVariant(data) {
  return {
          sku: data.sku,
          size_code: data.size_code,
          is_active: data.is_active
        };
}

function decodeItem(data) {
  return {
          order_id: data.order_id,
          product: decodeProduct(data.product),
          variant: decodeVariant(data.variant),
          quantity: data.quantity,
          unit_price_minor: data.unit_price_minor,
          total_price_minor: data.total_price_minor,
          currency_code: data.currency_code,
          created_at: data.created_at
        };
}

function tryDecodeAddress(json) {
  var data = PorterStoreOrderDetailApiModel.address_decode(json);
  if (data.TAG === /* Ok */0) {
    return decodeAddress(data._0);
  }
  
}

function decodeOrderDetail(data) {
  return {
          order_uuid: data.order_uuid,
          status: data.status,
          crm_status: data.crm_status,
          geo_region_id: data.geo_region_id,
          total_amount_minor: data.total_amount_minor,
          currency_code: data.currency_code,
          requester: Belt_Option.map(data.customer, decodeRequester),
          items: Belt_Array.map(data.items, decodeItem),
          address: tryDecodeAddress(data.address),
          created_at: data.created_at,
          updated_at: data.updated_at
        };
}

function execute(json) {
  return decodeOrderDetail(DeccoUtils$Catalyst.resolveResult(PorterStoreOrderDetailApiModel.t_decode(json), "PorterStoreOrderDetailEntityMapper.res"));
}

export {
  decodeAddress ,
  decodeRequester ,
  decodeProduct ,
  decodeVariant ,
  decodeItem ,
  tryDecodeAddress ,
  decodeOrderDetail ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
